import { LocalStorage } from '~/helpers';
import {
  resetUserData,
  setUserData as setUserDataAction,
} from '~/actions/user';
import { proceedChannelsApprove } from '~/actions/channel_manager';
import { getPrimus } from '~/utils/primus';
import userRequests from '~/api/user';
import { setStories } from '~/thunks/chatbot';
import { history as globalHistory } from '~/providers/auth/helpers';

export const setUserData = (payload) => (dispatch) => {
  const userData = Array.isArray(payload) ? payload[0] : payload;

  if (userData?._id && !userData.id) {
    userData.id = userData._id;
  }

  if (userData?.config?.chatbot_settings) {
    dispatch(
      setStories({
        enqueueSnackbar: () => {},
      })
    );
  }

  dispatch(setUserDataAction(userData));
};

let pollingTimeout;

export const signOut = () => (dispatch) => {
  const primus = getPrimus();

  LocalStorage.removeUser();
  LocalStorage.removeToken();

  dispatch(resetUserData());
  dispatch({ type: 'app/USER_LOGOUT' });

  clearTimeout(pollingTimeout);

  if (primus) primus.destroy();
};

/**
 * @param params {{
 *   enqueueSnackbar: Function
 *
 *   history?: History
 *   onError?: (error) => boolean | Promise<boolean>
 * }}
 * @param history
 * @returns {function(*): Promise<unknown>}
 */
export const fetchMe =
  ({ enqueueSnackbar, history, onError } = {}) =>
  async (dispatch) => {
    clearTimeout(pollingTimeout);

    return userRequests
      .getMWAccount()
      .then((response) => {
        const userData = {
          isVerified: response?.meta?.isVerified ?? false,
          isConnected: response?.meta?.is_settings_avaialble ?? false,
          balance: response?.balance ?? 0,
          credit_balance: response?.credit ?? 0,
          reserved_balance: response?.balance_reserved ?? 0,
          isPooling: true,
          unlimitedTopUp: (response?.meta?.permissions ?? []).some(
            (permission) => permission.code === 'unlimited_top_up'
          ),
        };

        dispatch(setUserData(userData));
        dispatch(proceedChannelsApprove());
        pollingTimeout = setTimeout(
          () => dispatch(fetchMe({ enqueueSnackbar, history })),
          60000
        );
      })
      .catch(async (error) => {
        if (onError && (await onError(error))) {
          return;
        }

        if (error.status === 401) {
          dispatch(signOut());

          (history || globalHistory).push('/auth/login');
        } else {
          enqueueSnackbar(error.message, { variant: 'error' });
          pollingTimeout = setTimeout(
            () => dispatch(fetchMe({ enqueueSnackbar, history })),
            60000
          );
        }
      });
  };
